/**
 * @desc 搜索报警消息(旧版)
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.AlertMessageSearchWapRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertMessageResponse>>> {
  return defHttp.post({
    url: '/wap/alert/message/search',
    data,
  });
}

export function mock(
  data: defs.AlertMessageSearchWapRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.AlertMessageResponse>>> {
  return defHttp.post({
    url: '/mock/wap/alert/message/search',
    data,
  });
}
